import { SetNewPasswordForm } from "./setNewPasswordForm";
import { Link, useParams } from "react-router";

export const ResetPasswordSetNewView = () => {
  const params = useParams<{ token: string }>();

  return (
    <>
      <SetNewPasswordForm token={params.token || ""} />
      <div className="mt-3">
        <p className="text-center text-sm text-ui-paragraph-text">
          Do you remember your password?{" "}
          <Link to="/login" className="font-medium text-primary hover:text-primary/80">
            Login here.
          </Link>
        </p>
      </div>
    </>
  );
};
